export default "__VITE_ASSET__e61433b5__"